import React, { useEffect, useState, useCallback } from "react";
import ReactPaginate from "react-paginate";
import api from "../../axiosConfig";
import {
  Table,
  Button,
  InputGroup,
  FormControl,
  Container,
} from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../pagination.css";
import { authFetch } from "../utils/authFetch";

const loadUmOptions = async (inputValue, _loaded, additional) => {
  const page = additional?.page ?? 1;
  const q = (inputValue || "").trim();
  const skip = (page - 1) * 20;

  try {
    // răspunsul tău este un array la root
    const data = await authFetch(`/bxums?search=${encodeURIComponent(q)}&skip=${skip}&limit=20`);
    const items = Array.isArray(data) ? data : (Array.isArray(data?.items) ? data.items : []);
    const options = items.map(u => ({
      value: u.id,
      label: `${u.cod ?? u.code ?? u.id} — ${u.descriere ?? u.denumire ?? u.name ?? ""}`.trim(),
    }));
    const hasMore = items.length === 20; // simplu: dacă au venit 20, mai este
    return { options, hasMore, additional: { page: page + 1 } };
  } catch (e) {
    console.error("loadUmOptions error", e);
    return { options: [], hasMore: false, additional: { page } };
  }
};




function BxumList() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("q") || "";

  // Căutare + paginare sincronizate cu backend-ul
  const fetchItems = useCallback(async () => {
    const skip = currentPage * itemsPerPage;
    try {
      const res = await api.get("/bxums", {
        params: {
          search,
          skip,
          limit: itemsPerPage,
        },
      });
      setItems(res.data.items);
      setTotalCount(res.data.total);
      // console.log("🧾 Răspuns complet:", res);
      // console.log("📦 Date din res.data:", res.data);
    } catch (err) {
      console.error("Eroare la încărcare:", err);
    }
  }, [search, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleSearchChange = (e) => {
    setSearchParams({ q: e.target.value });
    setCurrentPage(0); // reset pagină când cauți
  };

  const handleDelete = async (id) => {
    if (window.confirm("Sigur dorești să ștergi înregistrarea cu ID " + id + "?")) {
      try {
        await api.delete(`/bxums/${id}`);
        fetchItems(); // reîncărcăm lista după ștergere
      } catch (err) {
        alert("Eroare la ștergere.");
      }
    }
  };

  const pageCount = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  return (
    <Container className="mt-4">
      <h2>Unități de măsură</h2>


      <Button className="mb-3 d-block ms-auto" onClick={() => navigate("/bxum/new")}>
        Adaugă
      </Button>

      <InputGroup className="mb-3">
        <FormControl
          placeholder="Caută după denumire"
          value={search}
          onChange={handleSearchChange}
        />
        {search && (
          <Button variant="outline-danger" onClick={() => setSearchParams({})}>
            Curăță
          </Button>
        )}
      </InputGroup>

      <div className="mb-3">
        <label>
          Rânduri pe pagină:&nbsp;
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value));
              setCurrentPage(0);
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </label>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
              <th>cod</th>
              <th>descriere</th>
              <th>zecimale</th>
              <th>um_saft</th>
              <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <tr key={it.id}>
              <td>{it.id}</td>
              <td>{it.cod}</td>
              <td>{it.descriere}</td>
              <td>{it.zecimale}</td>
              <td>{it.um_saft}</td>
              <td>
                <Button
                  size="sm"
                  onClick={() => navigate(`/bxums/${it.id}/edit`)}

                >
                  Editează
                </Button>{" "}
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(it.id)}
                >
                  Șterge
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ReactPaginate
        previousLabel={"← Înapoi"}
        nextLabel={"Înainte →"}
        pageCount={pageCount}
        forcePage={currentPage}
        onPageChange={(event) => setCurrentPage(event.selected)}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </Container>
  );
}

export default BxumList;
